/**
 * Centralized registry of dev-only components.
 * Fully excluded from production builds using compile-time dead code elimination.
 *
 * Usage:
 * import { DevBadge } from 'components/dev-tools'
 *
 * <DevBadge />
 *
 * In production builds, Vite's tree-shaking removes all imports and component code.
 * Only empty function shells remain.
 */

import { lazy, Suspense } from 'react'

// These dynamic imports are fully tree-shaken in production builds
// Vite removes the entire import() expression when import.meta.env.DEV is false
const LazyDevBadge = import.meta.env.DEV
  ? lazy(() => import('./badge.dev').then((m) => ({ default: m.DevBadge })))
  : null

const LazyDevPermissionsPanel = import.meta.env.DEV
  ? lazy(() => import('./permissions-panel.dev').then((m) => ({ default: m.DevPermissionsPanel })))
  : null

export function DevBadge() {
  if (!import.meta.env.DEV || !LazyDevBadge) return null

  return (
    <Suspense fallback={null}>
      <LazyDevBadge />
    </Suspense>
  )
}

export function DevPermissionsPanel() {
  if (!import.meta.env.DEV || !LazyDevPermissionsPanel) return null

  return (
    <Suspense fallback={null}>
      <LazyDevPermissionsPanel />
    </Suspense>
  )
}
